module.exports = __webpack_public_path__ + "img/laundry.5df070b1.png";